import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { ListForecastYear } from 'src/app/core/models/forecast.models';
import {
	ForecastCampaignPeriods,
	ForecastCampaignService,
	ForecastCampaignTypeService,
} from '../../services/forecast-campaigns-list.service';
import { ListForecastServiceYear } from '../../services/forecastyear-list.service';
import { ListForecastServiceYearSearch } from '../../services/forecastyearsearch-list.service';
import { NgbdOrdersSortableHeaderYear } from '../../listjs-sortable-forecast-list.directive';

@Component({
	selector: 'app-real-year',
	templateUrl: './real-year.component.html',
	styleUrls: ['./real-year.component.scss'],
	providers: [
		ListForecastServiceYear,
		ForecastCampaignService,
		ForecastCampaignTypeService,
	],
})
export class RealYearComponent implements OnInit {
	ListJsListYear$!: Observable<ListForecastYear[]>;
	totalYear$: Observable<number>;
	@ViewChildren(NgbdOrdersSortableHeaderYear)
	headersYear!: QueryList<NgbdOrdersSortableHeaderYear>;

	//data Campaigns
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	submitted = false;
	isHidden: boolean = false;
	private selectedCampaignYear: number;
	selectedTypeCampaignYear = '';
	selectedPeriod: number;
	keyword = 'name';
	isSearch: boolean = false;

	constructor(
		public serviceyear: ListForecastServiceYear,
		public serviceyearsearch: ListForecastServiceYearSearch,
		private forecastCampaignService: ForecastCampaignService,
		private forecastCampaignTypeService: ForecastCampaignTypeService,
		public forecastCampaignPeriods: ForecastCampaignPeriods,
	) {
		this.ListJsListYear$ = serviceyear.list_result$;
		this.totalYear$ = serviceyear.total$;
	}

	ngOnInit(): void {
		this.forecastCampaignService
			.getCampaigns()
			.subscribe((response: any) => (this.campaignList = response.body));

		this.forecastCampaignTypeService
			.getCampaignTypes()
			.subscribe(
				(response: any) => (this.campaignTypeList = response.body),
			);

		this.forecastCampaignPeriods
			.getCampaignPeriods()
			.subscribe(
				(response: any) => (this.campaignPeriods = response.body),
			);
	}

	selectEventCampaignYear(item: any) {
		this.selectedCampaignYear = item.id;
		$('#weekSearch').val(item.id);
	}

	selectEventTypeYear(item: any) {
		this.selectedTypeCampaignYear = item.id;
	}

	selectEventPeriod(item: any) {
		this.selectedPeriod = item.name;
	}

	selectEvent(item: any) {}
	onChangeSearch(search: any) {}
	onFocused(e: any) {}

	get_year_filter(event: any) {
		let selectedCampaign = this.selectedCampaignYear;
		let selectedTypeCampaign = this.selectedTypeCampaignYear;
		let selectedPeriod = this.selectedPeriod;

		if (selectedPeriod > 0) {
			this.isHidden = false;
			this.isSearch = true;
			this.ListJsListYear$ = this.serviceyearsearch.SearchCampaign(
				selectedCampaign,
				selectedTypeCampaign,
				selectedPeriod,
			);
			this.totalYear$ = this.serviceyearsearch.total$;
		} else {
			this.isHidden = true;
			this.isSearch = false;
		}
	}
}
